import {updateAutoAdd, list} from "@/services/api/app/google/seat-management/backupsettings";

const defaultState = () => ({
  autoAdd: {
    users: true,
    sharedDrives: true,
    classrooms: true,
  },
  enabledClassroom: false,
});

export default {
  namespaced: true,

  actions: {
    list({commit}) {
      return list()
        .then((data) => {
          if (data?.autoAdd) {
            commit('setAutoAdd', data.autoAdd)
          }
          if (typeof data?.enabledClassroom !== 'undefined') {
            commit('setClassroomEnabled', data.enabledClassroom);
          }
        })
    },
    updateAutoAdd({commit}, data) {
      return updateAutoAdd(data)
        .then(({autoAdd}) => {
          commit('setAutoAdd', autoAdd)
        })
    },
  },

  mutations: {
    setAutoAdd(state, autoAdd) {
      state.autoAdd = autoAdd
    },
    setClassroomEnabled(state, enabledClassroom) {
      state.enabledClassroom = enabledClassroom;
    },
  },


  getters: {
    //seatType: users
    getAutoAddSettingByType: (state) => (seatType) => {
      return state.autoAdd && state.autoAdd[seatType];
    },
  },

  state: defaultState()
}
